import { useState } from "react";
import secureLocalStorage from "react-secure-storage";

export function useLocalStorage<T>(
    keyName: string,
    defaultValue?: string | null
) {
    const [storedValue, setStoredValue] = useState<T>(() => {
        try {
            const value = secureLocalStorage.getItem(keyName) as string;

            if (value) {
                return JSON.parse(value);
            } else {
                secureLocalStorage.setItem(
                    keyName,
                    JSON.stringify(defaultValue)
                );
                return defaultValue;
            }
        } catch (err) {
            return defaultValue;
        }
    });

    const setValue = (newValue: T) => {
        try {
            secureLocalStorage.setItem(keyName, JSON.stringify(newValue));
        } catch (err) {
            console.error(err);
        }
        setStoredValue(newValue);
    };

    const deleteValue = () => {
        try {
            secureLocalStorage.removeItem(keyName);
        } catch (err) {
            console.error(err);
        }
    };

    return { storedValue, setValue, deleteValue };
}
